export const buttonBaseBorderRadius = "9999px";
export const buttonBaseFocusRingColor = "#70c8be";
export const buttonBaseFocusRingWidth = "0.25rem /4*3";
export const buttonVariantsSizeSmPx = "1rem"; // x-padding for small buttons
export const buttonVariantsSizeSmPy = "0.5rem"; // y-padding for small buttons
export const buttonVariantsSizeSmItemSpacing = "0.5rem"; // spacing between items
export const buttonVariantsSizeSmTypography = "400 0.875rem/1.25rem Inter";
export const buttonVariantsSizeSmIconsDensity = "compact";
export const buttonVariantsSizeSmIconsSize = "20dp";
export const buttonVariantsSizeMdPx = "1.25rem"; // x-padding for medium buttons
export const buttonVariantsSizeMdPy = "0.625rem"; // y-padding for medium buttons
export const buttonVariantsSizeMdItemSpacing = "0.5rem"; // spacing between items
export const buttonVariantsSizeMdTypography = "400 0.875rem/1.25rem Inter";
export const buttonVariantsSizeMdIconsDensity = "compact";
export const buttonVariantsSizeMdIconsSize = "20dp";
export const buttonVariantsSizeLgPx = "1.25rem"; // x-padding for large buttons
export const buttonVariantsSizeLgPy = "0.75rem"; // y-padding for large buttons
export const buttonVariantsSizeLgItemSpacing = "0.5rem";
export const buttonVariantsSizeLgTypography = "400 1rem/1.5rem Inter";
export const buttonVariantsSizeLgIconsDensity = "compact";
export const buttonVariantsSizeLgIconsSize = "24dp";
export const buttonVariantsSizeXsPx = "1rem"; // x-padding for small buttons
export const buttonVariantsSizeXsPy = "0.5rem"; // y-padding for small buttons
export const buttonVariantsSizeXsItemSpacing = "0.5rem"; // spacing between items
export const buttonVariantsSizeXsTypography = "400 0.75rem/1rem Inter";
export const buttonVariantsSizeXsIconsDensity = "compact";
export const buttonVariantsSizeXsIconsSize = "16dp";
export const buttonVariantsStyleFilledSurfaceDefault = "#29a197";
export const buttonVariantsStyleFilledSurfaceHover = "#15938a";
export const buttonVariantsStyleFilledSurfaceActive = "#00857c";
export const buttonVariantsStyleFilledSurfaceFocus = "#15938a";
export const buttonVariantsStyleFilledSurfaceDisabled = "#c3c7c7";
export const buttonVariantsStyleFilledOnSurfaceDefault = "#fff";
export const buttonVariantsStyleFilledOnSurfaceDisabled = "#8f9191";
export const buttonVariantsStyleOutlinedSurfaceDefault = "#fff";
export const buttonVariantsStyleOutlinedSurfaceHover = "#f3faf9";
export const buttonVariantsStyleOutlinedSurfaceActive = "#e2f4f1";
export const buttonVariantsStyleOutlinedSurfaceFocus = "#f3faf9";
export const buttonVariantsStyleOutlinedSurfaceDisabled = "#eef2f2";
export const buttonVariantsStyleOutlinedOnSurfaceDefault = "#29a197";
export const buttonVariantsStyleOutlinedOnSurfaceDisabled = "#c3c7c7";
export const buttonVariantsStyleOutlinedBorderWidth = "1px"; // 1px
export const buttonVariantsStyleTonalSurfaceDefault = "#d5efec";
export const buttonVariantsStyleTonalSurfaceHover = "#c3e9e4";
export const buttonVariantsStyleTonalSurfaceActive = "#b4e4dd";
export const buttonVariantsStyleTonalSurfaceFocus = "#c3e9e4";
export const buttonVariantsStyleTonalSurfaceDisabled = "#dee2e2";
export const buttonVariantsStyleTonalOnSurfaceDefault = "#006a62";
export const buttonVariantsStyleTonalOnSurfaceDisabled = "#c3c7c7";
export const buttonVariantsStyleTextSurfaceDefault = "lch(100 0 0 / 0)";
export const buttonVariantsStyleTextSurfaceHover = "#f3faf9";
export const buttonVariantsStyleTextSurfaceActive = "#e2f4f1";
export const buttonVariantsStyleTextSurfaceFocus = "#f3faf9";
export const buttonVariantsStyleTextSurfaceDisabled = "lch(95.2 1.46 200 / 0)";
export const buttonVariantsStyleTextOnSurfaceDefault = "#29a197";
export const buttonVariantsStyleTextOnSurfaceDisabled = "#c3c7c7";
export const buttonSlotsBaseResizingW = "resizing-w-hug";
export const buttonSlotsBaseResizingH = "resizing-h-hug";
